import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import "./index.scss"

export default function ResourcePageCTA({ component }) {
  const { headline, button, fullWidth, subtitleText, background } = component
  const { hasBackgroundImage, backgroundColor, image } = background[0]
  // This is a comment for testing purposes
  return (
    <>
      {fullWidth ? (
        <div
          className="resource-page-cta full-width"
          style={{
            backgroundColor:
              hasBackgroundImage === false ? backgroundColor : "#fff",
          }}
        >
          {hasBackgroundImage && (
            <GatsbyImage image={getImage(image)} className="bg-image" />
          )}
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <h2 className="text-white oblique">{headline}</h2>
                <p className="text-white">{subtitleText}</p>
                <a href={button[0].linkUrl} className="btn btn-primary">
                  {button[0].label}
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="resource-page-cta-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div
                  className="resource-page-cta"
                  style={{
                    backgroundColor:
                      hasBackgroundImage === false ? backgroundColor : "#fff",
                  }}
                >
                  {hasBackgroundImage && (
                    <GatsbyImage image={getImage(image)} className="bg-image" />
                  )}
                  <div className="container">
                    <div className="row">
                      <div className="col-md-5">
                        <h2 className="text-white oblique">{headline}</h2>
                        <p className="text-white">{subtitleText}</p>
                        <a href={button[0].linkUrl} className="btn btn-primary">
                          {button[0].label}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
